<template>
  <div class="order_confirm_container">
    <div class="recipient">
      <div class="recipient_body">
        <div class="left">
          <img src="@/assets/icon／地址.png" alt="" />
        </div>
        <div class="rig">
          <div class="recipient_list">
            <div
              class="recipient_list_item"
              v-for="(item, index) in receivesList"
              :key="item.id"
              v-show="index < 2"
            >
              <div class="top">
                <div class="name">
                  {{ item.name }}
                </div>
                <div class="mobile">
                  {{ item.mobile }}
                </div>
              </div>
              <div class="address">
                {{ item.province + item.city + item.county + item.address }}
              </div>
            </div>
          </div>
          <div class="recipient_list">
            <div
              class="recipient_list_item"
              v-for="(item, index) in receivesList"
              :key="item.id"
              v-show="index >= 2 && show_more"
            >
              <div class="top">
                <div class="name">
                  {{ item.name }}
                </div>
                <div class="mobile">
                  {{ item.mobile }}
                </div>
              </div>
              <div class="address">
                {{ item.province + item.city + item.county + item.address }}
              </div>
            </div>
          </div>
          <div
            class="showmore"
            @click="showMore"
            v-if="receivesList.length < 3"
          >
            共{{ receivesList.length }}个收件人
          </div>
          <div
            class="showmore"
            @click="showMore"
            v-if="!show_more && receivesList.length > 3"
          >
            共{{ receivesList.length }}个收件人，展开更多
          </div>
          <div
            class="showmore"
            @click="showMore"
            v-if="show_more && receivesList.length > 3"
          >
            共{{ receivesList.length }}个收件人，收起
          </div>
        </div>
      </div>
    </div>
    <div class="order_body">
      <div class="step4 wrapper">
        <div class="title">
          选购礼品
        </div>

        <div class="good_wrapper">
          <div class="left">
            <img :src="goodInfo.picture" alt="" />
          </div>
          <div class="rig">
            <div class="title">
              {{ goodInfo.name }}
            </div>
            <div class="desc">
              <div class="weight">{{ Number(goodInfo.weight) * 1000 }}g/件</div>
              <div class="site">
                {{ goodInfo.site }}
              </div>
            </div>
            <div class="price">
              <span>￥</span>
              <span class="money"> {{ goodInfo.price }}</span>
            </div>
          </div>
        </div>
        <div class="order_desc">
          <div class="order_desc_item">
            <div class="label">购买数量</div>
            <div class="value">1</div>
          </div>
          <div class="order_desc_item">
            <div class="label">配送方式</div>
            <div class="value">
              {{ goodInfo.deliveryName }}/{{ goodInfo.deliveryPrice }}元
            </div>
          </div>
          <div class="order_desc_item">
            <div class="label">订单备注</div>
            <input
              type="text"
              placeholder="选填，备注信息"
              class="input"
              v-model="orderParams.comment"
            />
          </div>
          <div class="order_desc_total">
            <span> 共{{ receivesList.length }}个收件人 </span>
            <span class="total_label">
              运费:
              <span class="price">
                <span style="font-size:2.133vw">
                  ￥
                </span>

                {{ totalPrice.deliverySumPrice }}
              </span>
            </span>
            <span class="total_label">
              礼品:
              <span class="price">
                <span style="font-size:2.133vw">
                  ￥
                </span>
                {{ totalPrice.goodsSumPrice }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="pay_way">
        <div>支付方式</div>
        <div class="pay_icon">
          <img src="@/assets/icon／账户余额.png" alt="" />
          <span>账户余额</span>
        </div>
      </div>
    </div>
    <div class="submit_bar">
      <div class="left">
        <span class="total">
          合计
        </span>
        <div class="money">￥{{ totalPrice.giftSumPrice }}</div>
      </div>
      <div class="right">
        <van-button
          round
          type="info"
          style="width:117px"
          color="#f93244"
          @click="handleOrderInsert"
          >确认支付</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { orderInsert, accountGet, orderPay } from '@/api';
export default {
  data() {
    return {
      goodInfo: {},
      receivesList: [],
      totalPrice: {},
      show_more: false,
      orderParams: {},
      orderAmount: 0
    };
  },
  mounted() {
    //获取提交的订单信息
    this.orderParams = Vue.ls.get('orderParams');
    this.receivesList = this.orderParams.detailArray;
    //显示礼品和总价
    this.goodInfo = Vue.ls.get('goodInfo');
    this.totalPrice = Vue.ls.get('totalPrice');
  },

  methods: {
    async handleOrderInsert() {
      this.orderAmount = this.totalPrice.giftSumPrice;
      const res = await accountGet();
      //余额不足---支付失败
      if (res.data.balance < this.orderAmount) {
        let resultObj = {
          msg: '余额不足',
          type: 'fail'
        };
        Vue.ls.set('payResult', resultObj);
        this.$router.replace('/payResult');
      } else {
        const params = {
          id: this.$route.query.id,
          payway: 'BALANCE'
        };
        const res2 = await orderPay(params);
        if (res2.success) {
          let resultObj = {
            msg: '支付金额：￥' + this.orderAmount,
            type: 'success'
          };
          Vue.ls.set('payResult', resultObj);
          this.$router.replace('/payResult');
        } else {
          let resultObj = {
            msg: res2.msg,
            type: 'fail'
          };

          Vue.ls.set('payResult', resultObj);
          this.$router.replace('/payResult');
        }
      }
    },
    showMore() {
      this.show_more = !this.show_more;
    }
  }
};
</script>

<style lang="less" scoped>
.order_confirm_container {
  background: #f7f8fa;
  padding-bottom: 40vw;
}

.recipient {
  background-image: url(~@/assets/xd_bg.png);
  background-size: 100.133vw 35.6vw;
  background-repeat: no-repeat;
  padding-top: 6.4vw;
  padding-left: 3.2vw;
  margin-bottom: 3.2vw;
  .recipient_body {
    width: 93.6vw;

    background: #ffffff;
    border-radius: 2.133vw;
    padding: 1.067vw 3.2vw 3.2vw;
    display: flex;

    .left {
      margin-right: 3.2vw;
      margin-top: 4.267vw;
      img {
        width: 6.4vw;
        height: 6.4vw;
      }
    }

    .rig {
      flex: 1;
      .recipient_list {
        .recipient_list_item {
          width: 100%;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          padding: 2.133vw 0;
          &:last-child {
            border-bottom: 0;
          }
          .top {
            display: flex;
            font-size: 4vw;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            margin-bottom: 1.067vw;
            .name {
              margin-right: 3.2vw;
            }

            .mobile {
            }
          }

          .address {
            font-size: 3.467vw;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }

      .showmore {
        text-align: center;
        margin-top: 1.067vw;
        font-size: 3.467vw;
        color: #f93244;
      }
    }
  }
}
.order_body {
  padding: 0 3.2vw;
}
.step4 {
  .good_wrapper {
    display: flex;
    margin-bottom: 2.133vw;
    .left {
      width: 21.333vw;
      height: 21.333vw;
      border-radius: 1.067vw;
      margin-right: 2.133vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .rig {
      margin-top: 1.067vw;
      .title {
        font-size: 4vw;
        color: #333333;
        margin-bottom: 1.6vw;
        font-weight: 500;
      }
      .desc {
        color: #999999;
        margin-bottom: 5.333vw;
        display: flex;
        .weight {
          margin-right: 4.8vw;
          font-size: 3.2vw;
        }
        .site {
          font-size: 3.467vw;
        }
      }
      .price {
        font-family: Avenir-Heavy;
        font-weight: 550;
        color: #323233;
        .money {
          font-size: 4.533vw;
        }
      }
    }
  }
  .order_desc {
    .order_desc_item {
      display: flex;
      align-items: center;
      padding: 3.2vw 0;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      font-size: 3.733vw;
      .input {
        margin-left: 3.2vw;
        border: none;
        flex: 1;
      }
    }
    .order_desc_total {
      text-align: right;
      font-size: 3.2vw;
      padding: 3.2vw 0 0;
      color: rgba(0, 0, 0, 0.45);
      .total_label {
        color: rgba(0, 0, 0, 0.65);
      }
      .price {
        color: #f93244;
      }
    }
  }
}
.pay_way {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3.2vw;
  padding: 3.2vw;
  background: #ffffff;
  border-radius: 2.133vw;
  .pay_icon {
    display: flex;
    align-items: center;
    img {
      width: 4.267vw;
      height: 4.267vw;
      margin-right: 1.067vw;
    }
    span {
      font-size: 3.733vw;
      color: #f93244;
    }
  }
}
.wrapper {
  padding: 4.267vw 3.2vw 3.2vw;
  background: #ffffff;
  border-radius: 2.133vw;

  .title {
    font-size: 4vw;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 3.467vw;
  }
}
.submit_bar {
  height: 14.933vw;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 3.733vw;
  padding-right: 4.267vw;
  .left {
    display: flex;
    align-items: center;
    .total {
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.45);
      margin-right: 1.067vw;
    }
    .money {
      color: #f52907;
      font-size: 6.4vw;
      font-weight: 600;
    }
  }
}
</style>
